import { useEffect } from "react";

interface Props {
    modalId: string;
    title: string;
    buttonTitle: string;
    buttonStyle: string;
    children: any;
    size?: "modal-xl"|"modal-lg"|"modal-sm"
    actionClose?:any;
}


export const SegModal = ({ modalId, title, buttonTitle, buttonStyle, size = "modal-lg", actionClose, children }: Props) => {
    
    useEffect(() => {
        const modalElement = document.getElementById(modalId);

        if (modalElement) {
            const handleModalHidden = () => {
                actionClose();
            };

            modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

            return () => {
                modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
            };
        }
    }, [modalId]);


    return (
        <>
            <div className={`${buttonStyle}`} style={{cursor: "pointer"}} data-bs-toggle="modal" data-bs-target={`#${modalId}`}>
                {buttonTitle}
            </div>
            <div className="modal fade" id={modalId} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className={`modal-dialog modal-dialog-centered ${size}`}>
                    <div className="modal-content">
                        <div className="modal-header" style={{border: "none"}}>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body py-2 px-4">
                            {children}
                        </div>
                        {/*<div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary">Save changes</button>
                        </div>*/}
                    </div>
                </div>
            </div>
        </>
    )
}
